import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { Page, LandingContainer } from '@containers/layout';
import { IconButton, Text } from '@components/common';
import ResetForm from '@containers/auth/ResetForm';
import history from '@utils/history';

function ResetPage(props) {
  const { location } = props;

  const renderBackButton = () => {
    return (
      <IconButton
        onClick={() => {
          history.goBack();
        }}
        name="back"
        width={16}
        height={16}
        title="Back"
      />
    );
  };

  const renderInvalid = () => {
    return (
      <Page renderHeaderLeftButtons={renderBackButton}>
        <LandingContainer
          display="flex"
          flexDirection="column"
          justifyContent="center"
        >
          <Text>Invalid Request</Text>
        </LandingContainer>
      </Page>
    );
  };

  if (!location.search) {
    return renderInvalid();
  }

  const queryParams = qs.parse(location.search.substring(1));
  const { email, token } = queryParams || {};

  if (!email || !token) {
    return renderInvalid();
  }

  return (
    <Page renderHeaderLeftButtons={renderBackButton}>
      <LandingContainer
        display="flex"
        flexDirection="column"
        justifyContent="center"
      >
        <ResetForm email={email} resetToken={token} />
      </LandingContainer>
    </Page>
  );
}

ResetPage.propTypes = {
  location: PropTypes.object
};

export default ResetPage;
